/**
 * 无需布局的公共路由（登录等）
 */
export default [
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/LoginView.vue'),
    meta: { guestOnly: true }
  }
]
